export * from "modules/CommunicationTemplates/components/CommunicationTemplatesTable/components/CommunicationStatusIcon";
export * from "modules/CommunicationTemplates/components/CommunicationTemplatesTable/components/DuplicateTemplateButton";
